import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_BehavioralHealthAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_BehavioralHealthAssessment' className='file-pdf-document'>
            <div className='file-template'>



                <h3>DEMOGRAPHIC INFORMATION</h3>
                <table>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Age:</span> </td>
                        <td className='w-250'><span className='eleHeader'>DOB:</span></td>
                        <td className='w-250'><span className='eleHeader'>Ethinicity:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="text" id="txtAge" name="txtAge" className='add-only' /> </td>
                        <td className='w-250'> <input type="date" id="txtDob" name="txtDob" className='add-only' /> </td>
                        <td className='w-250'> <input type="text" id="txtEthinicity" name="txtEthinicity" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender Expression:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>SSN:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="text" id="txtGender" name="txtGender" className='add-only' /> </td>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtGenderExpression"
                                name="txtGenderExpression"
                                className='add-only' />
                        </td>
                        <td className='w-250'> <input type="text" id="txtSsn" name="txtSsn" className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Parent/Primary Caretaker Name::</span></td>
                        <td className='w-375'><span className='eleHeader'> Is this person, the legal guardian?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="text" id="txtParentCaretaker" name="txtParentCaretaker" placeholder='(first, middle, last)' className='add-only' /></td>
                        <td className='w-375'>

                            <input type="radio" id="rbLegalGuardian_Yes" name="rbLegalGuardian" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLegalGuardian_No" name="rbLegalGuardian" className='add-only' value="No" /> No (if not, enter information below)
                        </td>
                    </tr>

                    <tr>
                        <td className='w-300'><span className='eleHeader'>Legal Guardian Name:</span></td>
                        <td className='w-300'><span className='eleHeader'>Title/Department:</span></td>
                        <td className='w-150'><span className='eleHeader'>Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'><input type="text" id="txtLegalGuardian" name="txtLegalGuardian" placeholder='(first, middle, last)' className='add-only' /></td>
                        <td className='w-300'><input type="text" id="txtTitle" name="txtTitle" className='add-only' /></td>
                        <td className='w-150'><input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' /></td>
                    </tr>
                </table>


                <h3>BEHAVIORAL HEALTH HISTORY</h3>
                <p className='w-750'>
                    <strong>I. CHIEF COMPLAINT </strong>
                    <span className='small'>(Major symptoms, difficulties, and/or Issues as they relate to
                        behavioral health -in client/members's/caretaker's own words/quoted.)
                    </span>
                </p>

                <p className='w-750'>
                    <textarea id="txtReportedFelling"
                        name="txtReportedFelling"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>II. PRESENTING PROBLEM/HISTORY OF PRESENT ILLNESS</strong>
                    <span className='small'>(Including client/member/caretaker/guardian reason for seeking services,
                        precipitating factors, symptoms, behavioral and functioning
                        impacts, onset/course of issues, current behavioral health
                        providers, services sought and recipient expectation.)
                    </span>
                    <textarea id="txtDescribeImpairment"
                        name="txtDescribeImpairment"
                        className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CURRENT BEHAVIORAL HEALTH PROVIDER NAME:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PHONE NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtHealthProviderName"
                                name="txtHealthProviderName"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtHealthProviderPhoneNumber"
                                name="txtHealthProviderPhoneNumber"
                                className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>III. PAST PSYCHIATRIC/PLACEMENT HISTORY</strong>
                    <span className='small'>(First onset of illness, past diagnostic and treatment history,
                        medications, hospitalizations):
                    </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment:</span>
                    <input type="radio"
                        id="rbPriorOutpatientMentalHealthTreatment_Yes"
                        name="rbPriorOutpatientMentalHealthTreatment"
                        className='add-only'
                        value="Yes" /> Yes &nbsp;
                    <input type="radio"
                        id="rbPriorOutpatientMentalHealthTreatment_No"
                        name="rbPriorOutpatientMentalHealthTreatment"
                        className='add-only'
                        value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:
                    <br />
                    <textarea id="txtPriorOutpatientMentalHealthTreatmentDetail"
                        name="txtPriorOutpatientMentalHealthTreatmentDetail"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric Hospitalizations:</span>
                    <input type="radio"
                        id="rbPsychiatricHospitalizations_Yes"
                        name="rbPsychiatricHospitalizations"
                        className='add-only'
                        value="Yes" /> Yes &nbsp;
                    <input type="radio"
                        id="rbPsychiatricHospitalizations_No"
                        name="rbPsychiatricHospitalizations"
                        className='add-only'
                        value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:
                    <br />
                    <textarea id="txtPsychiatricHospitalizationsDetail"
                        name="txtPsychiatricHospitalizationsDetail"
                        className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Prior Residential/Out of Home Placement:</span>
                    <input type="radio" id="rbPriorResidential_Yes" name="rbPriorResidential" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbPriorResidential_No" name="rbPriorResidential" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    Detail:
                    <br />
                    <textarea id="txtPriorResidentialDetail" name="txtPriorResidentialDetail" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments:</span>
                    <textarea id="txtAdditionalHistoryComments"
                        name="txtAdditionalHistoryComments"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>IV. SUBSTANCE USE HISTORY </strong>
                    <span className='small'>(Past use of primary, secondary & tertiary current substance,
                        incl. type, freq, method & age of 1st use.)
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Check any/all that apply in past 12 months:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_1"
                                name="cbSubstanceAbuse_1"
                                className='add-only'
                                value="SubstanceAbuse_1" />Alcohol Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_2"
                                name="cbSubstanceAbuse_2"
                                className='add-only'
                                value="SubstanceAbuse_2" />Illegal Drug Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_3"
                                name="cbSubstanceAbuse_3"
                                className='add-only'
                                value="SubstanceAbuse_3" />Injected Drug Use;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_4"
                                name="cbSubstanceAbuse_4"
                                className='add-only'
                                value="SubstanceAbuse_4" />Tobacco Product Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_5"
                                name="cbSubstanceAbuse_5"
                                className='add-only'
                                value="SubstanceAbuse_5" />Prescription Drugs Abuse;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_6"
                                name="cbSubstanceAbuse_6"
                                className='add-only'
                                value="SubstanceAbuse_6" /> Non-Prescription (OTC) abuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_7"
                                name="cbSubstanceAbuse_7"
                                className='add-only'
                                value="SubstanceAbuse_7" />Alcohol and/or Drug Overdose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_8"
                                name="cbSubstanceAbuse_8"
                                className='add-only'
                                value="SubstanceAbuse_8" />Alcohol and/or Drug Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_9"
                                name="cbSubstanceAbuse_9"
                                className='add-only'
                                value="SubstanceAbuse_9" />Problems caused by gambling;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_10"
                                name="cbSubstanceAbuse_10"
                                className='add-only'
                                value="SubstanceAbuse_10" />Trouble stopping any substance;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuse_12"
                                name="cbSubstanceAbuse_12"
                                className='add-only'
                                value="SubstanceAbuse_12" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtSubstanceAbuse_12"
                                name="txtSubstanceAbuse_12"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse Treatment History:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_1"
                                name="cbSubstanceAbuseTreatmentHistory_1"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_1" /> None;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_2"
                                name="cbSubstanceAbuseTreatmentHistory_2"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_2" />Outpatient;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_3"
                                name="cbSubstanceAbuseTreatmentHistory_3"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_3" />Intensive Outpatient;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_4"
                                name="cbSubstanceAbuseTreatmentHistory_4"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_4" />Residential/Inpatient:;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_5"
                                name="cbSubstanceAbuseTreatmentHistory_5"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_5" />Detox;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSubstanceAbuseTreatmentHistory_6"
                                name="cbSubstanceAbuseTreatmentHistory_6"
                                className='add-only'
                                value="SubstanceAbuseTreatmentHistory_6" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtSubstanceAbuseTreatmentHistory_6"
                                name="txtSubstanceAbuseTreatmentHistory_6"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><strong>Hx of Drugs Used/Describe</strong></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(1) SUBSTANCE TYPE</span>
                            <span className='small'>Include all use in last 30 days.</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AGE OF 1ST USE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtSubstanceType_1"
                                name="txtSubstanceType_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAgeOfFirstUse_1"
                                name="txtAgeOfFirstUse_1"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtYearsInLifetime_1"
                                name="txtYearsInLifetime_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysInPast_1"
                                name="txtDaysInPast_1"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysSinceLastUsee_1"
                                name="txtDaysSinceLastUsee_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAmount_1"
                                name="txtAmount_1"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio"
                                id="rbRouteOfAdminOral_1"
                                name="rbRouteOfAdmin_1"
                                className='add-only'
                                value="Oral" /> Oral &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNasal_1"
                                name="rbRouteOfAdmin_1"
                                className='add-only'
                                value="Nasal" /> Nasal&nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminSmoking_1"
                                name="rbRouteOfAdmin_1"
                                className='add-only'
                                value="Smoking" /> Smoking &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNonIv_1"
                                name="rbRouteOfAdmin_1"
                                className='add-only'
                                value="NonIv" /> Non-IV Injxn &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminIv_1"
                                name="rbRouteOfAdmin_1"
                                className='add-only'
                                value="Iv" /> IV
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(2) SUBSTANCE TYPE</span>
                            <span className='small'>Include all use in last 30 days.</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AGE OF 1ST USE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtSubstanceType_2"
                                name="txtSubstanceType_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAgeOfFirstUse_2"
                                name="txtAgeOfFirstUse_2"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtYearsInLifetime_2"
                                name="txtYearsInLifetime_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysInPast_2"
                                name="txtDaysInPast_2"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysSinceLastUsee_2"
                                name="txtDaysSinceLastUsee_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAmount_2"
                                name="txtAmount_2"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio"
                                id="rbRouteOfAdminOral_2"
                                name="rbRouteOfAdmin_2"
                                className='add-only'
                                value="Oral" /> Oral &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNasal_2"
                                name="rbRouteOfAdmin_2"
                                className='add-only'
                                value="Nasal" /> Nasal&nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminSmoking_2"
                                name="rbRouteOfAdmin_2"
                                className='add-only'
                                value="Smoking" /> Smoking &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNonIv_2"
                                name="rbRouteOfAdmin_2"
                                className='add-only'
                                value="NonIv" /> Non-IV Injxn &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminIv_2"
                                name="rbRouteOfAdmin_2"
                                className='add-only'
                                value="Iv" /> IV
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(3) SUBSTANCE TYPE</span>
                            <span className='small'>Include all use in last 30 days.</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AGE OF 1ST USE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtSubstanceType_3"
                                name="txtSubstanceType_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAgeOfFirstUse_3"
                                name="txtAgeOfFirstUse_3"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtYearsInLifetime_3"
                                name="txtYearsInLifetime_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysInPast_3"
                                name="txtDaysInPast_3"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysSinceLastUsee_3"
                                name="txtDaysSinceLastUsee_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAmount_3"
                                name="txtAmount_3"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio"
                                id="rbRouteOfAdminOral_3"
                                name="rbRouteOfAdmin_3"
                                className='add-only'
                                value="Oral" /> Oral &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNasal_3"
                                name="rbRouteOfAdmin_3"
                                className='add-only'
                                value="Nasal" /> Nasal&nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminSmoking_3"
                                name="rbRouteOfAdmin_3"
                                className='add-only'
                                value="Smoking" /> Smoking &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNonIv_3"
                                name="rbRouteOfAdmin_3"
                                className='add-only'
                                value="NonIv" /> Non-IV Injxn &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminIv_3"
                                name="rbRouteOfAdmin_3"
                                className='add-only'
                                value="Iv" /> IV
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(4) SUBSTANCE TYPE</span>
                            <span className='small'>Include all use in last 30 days.</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AGE OF 1ST USE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtSubstanceType_4"
                                name="txtSubstanceType_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAgeOfFirstUse_4"
                                name="txtAgeOfFirstUse_4"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtYearsInLifetime_4"
                                name="txtYearsInLifetime_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysInPast_4"
                                name="txtDaysInPast_4"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysSinceLastUsee_4"
                                name="txtDaysSinceLastUsee_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAmount_4"
                                name="txtAmount_4"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio"
                                id="rbRouteOfAdminOral_4"
                                name="rbRouteOfAdmin_4"
                                className='add-only'
                                value="Oral" /> Oral &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNasal_4"
                                name="rbRouteOfAdmin_4"
                                className='add-only'
                                value="Nasal" /> Nasal&nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminSmoking_4"
                                name="rbRouteOfAdmin_4"
                                className='add-only'
                                value="Smoking" /> Smoking &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNonIv_4"
                                name="rbRouteOfAdmin_4"
                                className='add-only'
                                value="NonIv" /> Non-IV Injxn &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminIv_4"
                                name="rbRouteOfAdmin_4"
                                className='add-only'
                                value="Iv" /> IV
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(5) SUBSTANCE TYPE</span>
                            <span className='small'>Include all use in last 30 days.</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AGE OF 1ST USE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtSubstanceType_5"
                                name="txtSubstanceType_5"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAgeOfFirstUse_5"
                                name="txtAgeOfFirstUse_5"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>YEARS IN LIFETIME</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS IN PAST 30</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtYearsInLifetime_5"
                                name="txtYearsInLifetime_5"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysInPast_5"
                                name="txtDaysInPast_5"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DAYS SINCE LAST USE</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AMOUNT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDaysSinceLastUsee_5"
                                name="txtDaysSinceLastUsee_5"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtAmount_5"
                                name="txtAmount_5"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio"
                                id="rbRouteOfAdminOral_5"
                                name="rbRouteOfAdmin_5"
                                className='add-only'
                                value="Oral" /> Oral &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNasal_5"
                                name="rbRouteOfAdmin_5"
                                className='add-only'
                                value="Nasal" /> Nasal&nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminSmoking_5"
                                name="rbRouteOfAdmin_5"
                                className='add-only'
                                value="Smoking" /> Smoking &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminNonIv_5"
                                name="rbRouteOfAdmin_5"
                                className='add-only'
                                value="NonIv" /> Non-IV Injxn &nbsp;&nbsp;
                            <input type="radio"
                                id="rbRouteOfAdminIv_5"
                                name="rbRouteOfAdmin_5"
                                className='add-only'
                                value="Iv" /> IV
                        </td>
                    </tr>
                </table>

                <h3>PHYSICAL</h3>

                <p className='w-750'>
                    <strong>V. CURRENT MEDICAL CONDITIONS </strong>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_1"
                                name="cbMedicalConditions_1"
                                className='add-only'
                                value="MedicalConditions_1" />Pregnant
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbMedicalConditions_2"
                                name="cbMedicalConditions_2"
                                className='add-only'
                                value="MedicalConditions_2" />Due date:
                            &nbsp;
                            <input type="date"
                                id="txtMedicalConditions_2"
                                name="txtMedicalConditions_2"
                                className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbMedicalConditions_3"
                                name="cbMedicalConditions_3"
                                className='add-only'
                                value="MedicalConditions_3" />Prenatal care?
                            &nbsp;
                            <input
                                type="text"
                                id="txtMedicalConditions_3"
                                name="txtMedicalConditions_3"
                                className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_4"
                                name="cbMedicalConditions_4"
                                className='add-only'
                                value="MedicalConditions_4" /> None Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_5"
                                name="cbMedicalConditions_5"
                                className='add-only'
                                value="MedicalConditions_5" />Congestive Heart Failure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_6"
                                name="cbMedicalConditions_6"
                                className='add-only'
                                value="MedicalConditions_6" />Asthma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_7"
                                name="cbMedicalConditions_7"
                                className='add-only'
                                value="MedicalConditions_7" />Seizure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_8"
                                name="cbMedicalConditions_8"
                                className='add-only'
                                value="MedicalConditions_8" />Cancer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_9"
                                name="cbMedicalConditions_9"
                                className='add-only'
                                value="MedicalConditions_9" />Underweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_10"
                                name="cbMedicalConditions_10"
                                className='add-only'
                                value="MedicalConditions_10" />High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_11"
                                name="cbMedicalConditions_11"
                                className='add-only'
                                value="MedicalConditions_11" />Stroke
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_12"
                                name="cbMedicalConditions_12"
                                className='add-only'
                                value="MedicalConditions_12" />Emphysema
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_13"
                                name="cbMedicalConditions_13"
                                className='add-only'
                                value="MedicalConditions_13" />Cirrhosis
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_14"
                                name="cbMedicalConditions_14"
                                className='add-only'
                                value="MedicalConditions_14" />Chronic Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_15"
                                name="cbMedicalConditions_15"
                                className='add-only'
                                value="MedicalConditions_15" />Overweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_16"
                                name="cbMedicalConditions_16"
                                className='add-only'
                                value="MedicalConditions_16" />Heart Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_17"
                                name="cbMedicalConditions_17"
                                className='add-only'
                                value="MedicalConditions_17" />Diabetes
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_18"
                                name="cbMedicalConditions_18"
                                className='add-only'
                                value="MedicalConditions_18" />Epilepsy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_19"
                                name="cbMedicalConditions_19"
                                className='add-only'
                                value="MedicalConditions_19" />Digestive Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_20"
                                name="cbMedicalConditions_20"
                                className='add-only'
                                value="MedicalConditions_20" />Thyroid Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_21"
                                name="cbMedicalConditions_21"
                                className='add-only'
                                value="MedicalConditions_21" />Sexually Transmitted Dz.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMedicalConditions_22"
                                name="cbMedicalConditions_22"
                                className='add-only'
                                value="MedicalConditions_22" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtMedicalConditions_22"
                                name="txtMedicalConditions_22"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <strong>VI. CURRENT & PAST MEDICATIONS</strong>
                    <span className='small'>(Including non-psychotropic medications)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(1) Medication Name</span>
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtMedicationName_1"
                                name="txtMedicationName_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dose</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Freq.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDose_1"
                                name="txtDose_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtFreq_1"
                                name="txtFreq_1"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRoute_1"
                                name="txtRoute_1"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio"
                                id="rbCurrentYes_1"
                                name="rbCurrent_1"
                                className='add-only'
                                value="Yes" /> Yes &nbsp;
                            <input type="radio"
                                id="rbCurrentNo_1"
                                name="rbCurrent_1"
                                className='add-only'
                                value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <p className='w-750'>
                                <span className='eleHeader'>COMMENTS</span>
                                <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            </p>
                            <textarea id="txtComments_1"
                                name="txtComments_1"
                                className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(2) Medication Name</span>
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtMedicationName_2"
                                name="txtMedicationName_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dose</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Freq.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDose_2"
                                name="txtDose_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtFreq_2"
                                name="txtFreq_2"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRoute_2"
                                name="txtRoute_2"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio"
                                id="rbCurrentYes_2"
                                name="rbCurrent_2"
                                className='add-only'
                                value="Yes" /> Yes &nbsp;
                            <input type="radio"
                                id="rbCurrentNo_2"
                                name="rbCurrent_2"
                                className='add-only'
                                value="No" /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <p className='w-750'>
                                <span className='eleHeader'>COMMENTS</span>
                                <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            </p>
                            <textarea id="txtComments_2"
                                name="txtComments_2"
                                className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(3) Medication Name</span>
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtMedicationName_3"
                                name="txtMedicationName_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dose</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Freq.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDose_3"
                                name="txtDose_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtFreq_3"
                                name="txtFreq_3"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRoute_3"
                                name="txtRoute_3"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio"
                                id="rbCurrentYes_3"
                                name="rbCurrent_3"
                                className='add-only'
                                value="Yes" /> Yes &nbsp;
                            <input type="radio"
                                id="rbCurrentNo_3"
                                name="rbCurrent_3"
                                className='add-only'
                                value="No" /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <p className='w-750'>
                                <span className='eleHeader'>COMMENTS</span>
                                <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            </p>
                            <textarea id="txtComments_3"
                                name="txtComments_3"
                                className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>(4) Medication Name</span>
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtMedicationName_4"
                                name="txtMedicationName_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Dose</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Freq.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtDose_4"
                                name="txtDose_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtFreq_4"
                                name="txtFreq_4"
                                className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRoute_4"
                                name="txtRoute_4"
                                className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio"
                                id="rbCurrentYes_4"
                                name="rbCurrent_4"
                                className='add-only'
                                value="Yes" /> Yes &nbsp;
                            <input type="radio"
                                id="rbCurrentNo_4"
                                name="rbCurrent_4"
                                className='add-only'
                                value="No" /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <p className='w-750'>
                                <span className='eleHeader'>COMMENTS</span>
                                <span className='small'>(Reason Prescribed/Response, etc.)</span>
                            </p>
                            <textarea id="txtComments_4"
                                name="txtComments_4"
                                className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>VII. ALLERGIES</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbAllergies_Food"
                                name="cbAllergies_Food"
                                className='add-only'
                                value="Allergies_Food" /> No Reported Drug or Food Allergies;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbAllergies_Other"
                                name="cbAllergies_Other"
                                className='add-only'
                                value="Allergies_Other" />Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAllergies_OtherDescribe"
                        name="txtAllergies_OtherDescribe"
                        className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>VIII. PRIMARY CARE PHYSICIAN</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'><strong>NAME</strong></td>
                        <td className='w-250'><strong>PHONE</strong></td>
                        <td className='w-250'>
                            <strong>FAX </strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtPhysicianName"
                                name="txtPhysicianName"
                                className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtPhysicianPhone"
                                name="txtPhysicianPhone"
                                className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtPhysicianFax"
                                name="txtPhysicianFax"
                                className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>IX. ADDITIONAL SIGNIFICANT MEDICAL HISTORY
                    </span>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of
                        conditions, etc.)
                    </span>
                </p>

                <p className='w-750'>
                    <textarea id="txtAdditionalMedicalHistory"
                        name="txtAdditionalMedicalHistory"
                        className='add-only'></textarea>
                </p>

                <h3>SOCIAL</h3>
                <p className='w-750'><strong>X. LEGAL STATUS</strong></p>
                <p className='w-750'><span className='eleHeader'>Current Legal Status:</span></p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCurrentLegalStatus_1" name="cbCurrentLegalStatus_1" className='add-only' value="CurrentLegalStatus_1" />  None;
                        </td>
                        <td className='w-150'>
                            <input type="checkbox"
                                id="cbCurrentLegalStatus_2"
                                name="cbCurrentLegalStatus_2"
                                className='add-only'
                                value="CurrentLegalStatus_2" />
                            Probation;
                        </td>
                        <td className='w-150'>
                            <input type="checkbox"
                                id="cbCurrentLegalStatus_3"
                                name="cbCurrentLegalStatus_3"
                                className='add-only'
                                value="CurrentLegalStatus_3" />
                            Charges Pending;
                        </td>
                        <td className='w-150'>
                            <input type="checkbox"
                                id="cbCurrentLegalStatus_4"
                                name="cbCurrentLegalStatus_4"
                                className='add-only'
                                value="CurrentLegalStatus_4" />
                            DCFS;
                        </td>
                        <td className='w-150'>
                            <input type="checkbox"
                                id="cbCurrentLegalStatus_5"
                                name="cbCurrentLegalStatus_5"
                                className='add-only'
                                value="CurrentLegalStatus_5" />
                            OJJ;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCurrentLegalStatus_8"
                                name="cbCurrentLegalStatus_8"
                                className='add-only'
                                value="CurrentLegalStatus_8" />
                            Other;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Comment/Detail:</strong>
                    <textarea id="txtCurrentLegalStatusComment"
                        name="txtCurrentLegalStatusComment"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Past Legal Status:</span></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPastLegalStatus_1"
                                name="cbPastLegalStatus_1"
                                className='add-only'
                                value="PastLegalStatus_1" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPastLegalStatus_2"
                                name="cbPastLegalStatus_2"
                                className='add-only'
                                value="PastLegalStatus_2" />
                            DCFS;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPastLegalStatus_3"
                                name="cbPastLegalStatus_3"
                                className='add-only'
                                value="PastLegalStatus_3" />
                            OJJ;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPastLegalStatus_5"
                                name="cbPastLegalStatus_5"
                                className='add-only'
                                value="PastLegalStatus_5" />Other;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Comment/Detail:</strong>
                    <textarea id="txtPastLegalStatusComment"
                        name="txtPastLegalStatusComment"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XI. FAMILY HISTORY </strong>
                    <span className='small'>(relationship status with relatives, family involvement in
                        treatment, and living status of significant relatives):
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Custodial Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_1"
                                name="cbCustodialStatus_1"
                                className='add-only'
                                value="CustodialStatus_1" />Independent Adult;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_2"
                                name="cbCustodialStatus_2"
                                className='add-only'
                                value="CustodialStatus_2" />Biological Father;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_3"
                                name="cbCustodialStatus_3"
                                className='add-only'
                                value="CustodialStatus_3" />Biological Mother;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_4"
                                name="cbCustodialStatus_4"
                                className='add-only'
                                value="CustodialStatus_4" />Joint Biological Parents;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_5"
                                name="cbCustodialStatus_5"
                                className='add-only'
                                value="CustodialStatus_5" />Gov't/Judicial;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbCustodialStatus_6"
                                name="cbCustodialStatus_6"
                                className='add-only'
                                value="CustodialStatus_6" />Other:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input
                                type="text"
                                id="txtCustodialStatus_6"
                                name="txtCustodialStatus_6"
                                className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Adverse Circumstances in Family of Origin:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_1"
                                name="cbAdverseCircumstances_1"
                                className='add-only'
                                value="AdverseCircumstances_1" />N/A;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_2"
                                name="cbAdverseCircumstances_2"
                                className='add-only'
                                value="AdverseCircumstances_2" />Poverty;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_3"
                                name="cbAdverseCircumstances_3"
                                className='add-only'
                                value="AdverseCircumstances_3" />
                            Criminal Behavioral;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_4"
                                name="cbAdverseCircumstances_4"
                                className='add-only'
                                value="AdverseCircumstances_4" />Mental Illness;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_5"
                                name="cbAdverseCircumstances_5"
                                className='add-only'
                                value="AdverseCircumstances_5" />Substance Use;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_6"
                                name="cbAdverseCircumstances_6"
                                className='add-only'
                                value="AdverseCircumstances_6" />Abuse;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_7"
                                name="cbAdverseCircumstances_7"
                                className='add-only'
                                value="AdverseCircumstances_7" />Neglect;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_8"
                                name="cbAdverseCircumstances_8"
                                className='add-only'
                                value="AdverseCircumstances_8" />Domestic Violence;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_9"
                                name="cbAdverseCircumstances_9"
                                className='add-only'
                                value="AdverseCircumstances_9" />
                            Violence;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_10"
                                name="cbAdverseCircumstances_10"
                                className='add-only'
                                value="AdverseCircumstances_10" />Trauma;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbAdverseCircumstances_12"
                                name="cbAdverseCircumstances_12"
                                className='add-only'
                                value="AdverseCircumstances_12" />Other/Describe:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input
                                type="text"
                                id="txtAdverseCircumstances_12"
                                name="txtAdverseCircumstances_12"
                                className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Summarize family history and child-rearing practices:</span>
                    <textarea id="txtSummarizeFamilyHistory"
                        name="txtSummarizeFamilyHistory"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'><strong>XII. TRAUMA HISTORY</strong></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>History of Trauma:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_1"
                                name="cbHistoryTrauma_1"
                                className='add-only'
                                value="HistoryTrauma_1" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_2"
                                name="cbHistoryTrauma_2"
                                className='add-only'
                                value="HistoryTrauma_2" />
                            Experienced;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_3"
                                name="cbHistoryTrauma_3"
                                className='add-only'
                                value="HistoryTrauma_3" />
                            Witnessed;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_4"
                                name="cbHistoryTrauma_4"
                                className='add-only'
                                value="HistoryTrauma_4" />
                            Abuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_5"
                                name="cbHistoryTrauma_5"
                                className='add-only'
                                value="HistoryTrauma_5" />
                            Neglect;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_6"
                                name="cbHistoryTrauma_6"
                                className='add-only'
                                value="HistoryTrauma_6" />
                            Violence;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_7"
                                name="cbHistoryTrauma_7"
                                className='add-only'
                                value="HistoryTrauma_7" />
                            Sexual Assault;
                        </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbHistoryTrauma_8"
                                name="cbHistoryTrauma_8"
                                className='add-only'
                                value="HistoryTrauma_8" />Other/Describe:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input
                                type="text"
                                id="txtHistoryTrauma_8"
                                name="txtHistoryTrauma_8"
                                className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Summarize Trauma history:</span>
                    <textarea id="txtSummarizeTraumaHistory"
                        name="txtSummarizeTraumaHistory"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XIII. LIVING SITUATION </strong>
                    <span className='small'>(Current status and functioning)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Primary Residence: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPrimaryResidence_1"
                                name="cbPrimaryResidence_1"
                                className='add-only'
                                value="PrimaryResidence_1" /> Parent/Guardian Home;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPrimaryResidence_2"
                                name="cbPrimaryResidence_2"
                                className='add-only'
                                value="PrimaryResidence_2" /> Relative's Home;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPrimaryResidence_3"
                                name="cbPrimaryResidence_3"
                                className='add-only'
                                value="PrimaryResidence_3" /> Out of Home placement;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPrimaryResidence_4"
                                name="cbPrimaryResidence_4"
                                className='add-only'
                                value="PrimaryResidence_4" /> Homeless;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox"
                                id="cbPrimaryResidence_7"
                                name="cbPrimaryResidence_7"
                                className='add-only'
                                value="PrimaryResidence_7" />Other/Describe:
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input
                                type="text"
                                id="txtPrimaryResidence_7"
                                name="txtPrimaryResidence_7"
                                className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>How long at current residence?
                    </span>
                    <textarea id="txtAtCurrentResidence"
                        name="txtAtCurrentResidence"
                        className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family/Household Composition:</span>
                    <textarea id="txtClientLiveWith"
                        name="txtClientLiveWith"
                        className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Summarize current living situation:</span>
                    <textarea id="txtSummarizeLivingSituation"
                        name="txtSummarizeLivingSituation"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XIV. EDUCATIONAL/EMPLOYMENT STATUS</strong>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>a. Current Educational Placement/Employer:</span>
                    <textarea id="txtCurrentEducationalPlacement"
                        name="txtCurrentEducationalPlacement"
                        className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'> Current or Highest Grade Completed/Degree:</span></td>
                        <td className='w-375'><span className='eleHeader'> Difficulties with Reading/Writing:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="text" id="txtHighestGradeCompleted" name="txtHighestGradeCompleted" className='add-only' /></td>
                        <td className='w-375'>

                            <input type='radio' id='rbDifficultiesReading_Yes' name='rbDifficultiesReading' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultiesReading_No' name='rbDifficultiesReading' className='add-only' value='No' />  No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Estimated Literacy Level:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="text" id="txtEstimatedLiteracyLevel" name="txtEstimatedLiteracyLevel" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>b. Summarize educational history and status: </span>
                    <textarea id="txtSummarizeEducationalHistory"
                        name="txtSummarizeEducationalHistory"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'><strong>XV. SOCIAL HISTORY AND COMMUNITY INTEGRATION</strong></p>

                <p className='w-750'>
                    <strong>a. Current status and functioning </strong>
                    <span className='small'>(Involvement in the community, social supports and activities,
                        social barriers)
                    </span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does Client/Member feel supported by friends or family?</span>
                    <input type="radio"
                        id="rbFeelSupportedByFriends_Yes"
                        name="rbFeelSupportedByFriends"
                        className='add-only'
                        value="Yes" /> Yes &nbsp;
                    <input type="radio"
                        id="rbFeelSupportedByFriends_No"
                        name="rbFeelSupportedByFriends"
                        className='add-only'
                        value="No" /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities : </span>
                    <textarea id="txtRecreationalActivities"
                        name="txtRecreationalActivities"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities : </span>
                    <textarea id="txtSelfHelpActivities"
                        name="txtSelfHelpActivities"
                        className='add-only'></textarea>
                </p>
                <p className='w-750'>

                    <span className='eleHeader'> b. Summarize social and community involvement:</span>
                    <textarea id="txtSummarizeSocialCommunityInvolvment"
                        name="txtSummarizeSocialCommunityInvolvment"
                        className='add-only'></textarea>
                </p>

                {/* <p className='w-750'>
                    <span className='eleHeader'>Additional Comments: </span>
                    <span className='small'>(Include psychological and social adjustments made to
                        disabilities and/or disorders.)
                    </span>
                </p>
                <p className='w-750'>
                    <textarea id="txtCurrentStatusAdditionalComments"
                        name="txtCurrentStatusAdditionalComments"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>b. Needs</span>
                    <span className='small'>List what is needed to improve/maintain recreation, social
                        functioning & community integration. (Ex. Meet new people,
                        painting supplies, sports team, improve family relationships
                        etc.)
                    </span>
                    <textarea id="txtNeedsXV"
                        name="txtNeedsXV"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>c. Preferences</span>
                    <span className='small'>Include things recipient feels will enhance or stimulate
                        recreational interests, social functioning & community
                        integration.
                    </span>
                    <textarea id="txtPreferencesXV"
                        name="txtPreferencesXV"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>d. Strengths</span>
                    <span className='small'>List assets, service options & skills that may enhance
                        socialization & community integration. (Ex. Friendly, athletic,
                        independent, friend plays, paints, past history of compliance in
                        treatment, signs of resilience despite past adversity,
                        etc.)
                    </span>
                    <textarea id="txtStrengthsXV"
                        name="txtStrengthsXV"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>e. Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, talents &
                        competencies that may help maintain or improve socialization &
                        community functioning.
                    </span>
                    <textarea id="txtAbilitiesInterestsXV"
                        name="txtAbilitiesInterestsXV"
                        className='add-only'></textarea>
                </p> */}

                <h3>CURRENT STATUS</h3>
                <p className='w-750'>
                    <strong>XVI. MENTAL STATUS EXAMINATION</strong>
                    <span className='small'>(Circle or Check all that apply.)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. GENERAL APPEARANCE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_1"
                                name="cbGeneralAppearance_1"
                                className='add-only'
                                value="GeneralAppearance_1" />
                            Healthy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_2"
                                name="cbGeneralAppearance_2"
                                className='add-only'
                                value="GeneralAppearance_2" />
                            As stated Age;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_3"
                                name="cbGeneralAppearance_3"
                                className='add-only'
                                value="GeneralAppearance_3" />
                            Older Than Stated Age;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_4"
                                name="cbGeneralAppearance_4"
                                className='add-only'
                                value="GeneralAppearance_4" />
                            Young-looking;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_5"
                                name="cbGeneralAppearance_5"
                                className='add-only'
                                value="GeneralAppearance_5" />
                            Tattoos;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_6"
                                name="cbGeneralAppearance_6"
                                className='add-only'
                                value="GeneralAppearance_6" />
                            Disheveled;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_7"
                                name="cbGeneralAppearance_7"
                                className='add-only'
                                value="GeneralAppearance_7" />
                            Unkempt;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_8"
                                name="cbGeneralAppearance_8"
                                className='add-only'
                                value="GeneralAppearance_8" />
                            Malodorous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_9"
                                name="cbGeneralAppearance_9"
                                className='add-only'
                                value="GeneralAppearance_9" />
                            Thin;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_10"
                                name="cbGeneralAppearance_10"
                                className='add-only'
                                value="GeneralAppearance_10" />
                            Overweight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_11"
                                name="cbGeneralAppearance_11"
                                className='add-only'
                                value="GeneralAppearance_11" />
                            Obese;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbGeneralAppearance_12"
                                name="cbGeneralAppearance_12"
                                className='add-only'
                                value="GeneralAppearance_12" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtGeneralAppearance_12"
                                name="txtGeneralAppearance_12"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_1"
                                name="cbPsychomotorActivity_1"
                                className='add-only'
                                value="PsychomotorActivity_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_2"
                                name="cbPsychomotorActivity_2"
                                className='add-only'
                                value="PsychomotorActivity_2" />
                            Overactive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_3"
                                name="cbPsychomotorActivity_3"
                                className='add-only'
                                value="PsychomotorActivity_3" />
                            Hypoactive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_4"
                                name="cbPsychomotorActivity_4"
                                className='add-only'
                                value="PsychomotorActivity_4" />
                            Catatonia;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_5"
                                name="cbPsychomotorActivity_5"
                                className='add-only'
                                value="PsychomotorActivity_5" />
                            Tremor;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_6"
                                name="cbPsychomotorActivity_6"
                                className='add-only'
                                value="PsychomotorActivity_6" />
                            Tics;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_7"
                                name="cbPsychomotorActivity_7"
                                className='add-only'
                                value="PsychomotorActivity_7" />
                            Combative;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPsychomotorActivity_9"
                                name="cbPsychomotorActivity_9"
                                className='add-only'
                                value="PsychomotorActivity_9" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtPsychomotorActivity_9"
                                name="txtPsychomotorActivity_9"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c. ATTITUDE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_1"
                                name="cbAtitude_1"
                                className='add-only'
                                value="Atitude_1" />
                            Optimal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_2"
                                name="cbAtitude_2"
                                className='add-only'
                                value="Atitude_2" />
                            Constructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_3"
                                name="cbAtitude_3"
                                className='add-only'
                                value="Atitude_3" />
                            Motivated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_4"
                                name="cbAtitude_4"
                                className='add-only'
                                value="Atitude_4" />
                            Obstructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_5"
                                name="cbAtitude_5"
                                className='add-only'
                                value="Atitude_5" />
                            Adversarial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_6"
                                name="cbAtitude_6"
                                className='add-only'
                                value="Atitude_6" />
                            Inaccessible;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_7"
                                name="cbAtitude_7"
                                className='add-only'
                                value="Atitude_7" />
                            Cooperative;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_8"
                                name="cbAtitude_8"
                                className='add-only'
                                value="Atitude_8" />
                            Seductive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_9"
                                name="cbAtitude_9"
                                className='add-only'
                                value="Atitude_9" />
                            Defensive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_10"
                                name="cbAtitude_10"
                                className='add-only'
                                value="Atitude_10" />
                            Hostile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_11"
                                name="cbAtitude_11"
                                className='add-only'
                                value="Atitude_11" />
                            Guarded;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_12"
                                name="cbAtitude_12"
                                className='add-only'
                                value="Atitude_12" />
                            Apathetic;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_13"
                                name="cbAtitude_13"
                                className='add-only'
                                value="Atitude_13" />
                            Evasive;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAtitude_14"
                                name="cbAtitude_14"
                                className='add-only'
                                value="Atitude_14" />Other/Explain:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtAtitude_14"
                                name="txtAtitude_14"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>d. SPEECH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_1"
                                name="cbSpeech_1"
                                className='add-only'
                                value="Speech_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_2"
                                name="cbSpeech_2"
                                className='add-only'
                                value="Speech_2" />
                            Spontaneous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_3"
                                name="cbSpeech_3"
                                className='add-only'
                                value="Speech_3" />
                            Slow;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_4"
                                name="cbSpeech_4"
                                className='add-only'
                                value="Speech_4" />
                            Impoverished;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_5"
                                name="cbSpeech_5"
                                className='add-only'
                                value="Speech_5" />
                            Hesitant;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_6"
                                name="cbSpeech_6"
                                className='add-only'
                                value="Speech_6" />
                            Monotonous;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_7"
                                name="cbSpeech_7"
                                className='add-only'
                                value="Speech_7" />
                            Soft/Whispered;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_8"
                                name="cbSpeech_8"
                                className='add-only'
                                value="Speech_8" />
                            Mumbled;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_9"
                                name="cbSpeech_9"
                                className='add-only'
                                value="Speech_9" />
                            Rapid;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_10"
                                name="cbSpeech_10"
                                className='add-only'
                                value="Speech_10" />
                            Pressured;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_11"
                                name="cbSpeech_11"
                                className='add-only'
                                value="Speech_11" />
                            Verbose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_12"
                                name="cbSpeech_12"
                                className='add-only'
                                value="Speech_12" />
                            Loud;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_13"
                                name="cbSpeech_13"
                                className='add-only'
                                value="Speech_13" />
                            Slurred;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_14"
                                name="cbSpeech_14"
                                className='add-only'
                                value="Speech_14" />
                            Impediment;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSpeech_15"
                                name="cbSpeech_15"
                                className='add-only'
                                value="Speech_15" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtSpeech_15"
                                name="txtSpeech_15"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>e. MOOD</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_1"
                                name="cbMood_1"
                                className='add-only'
                                value="Mood_1" />
                            Dysphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_2"
                                name="cbMood_2"
                                className='add-only'
                                value="Mood_2" />
                            Euthymic ;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_3"
                                name="cbMood_3"
                                className='add-only'
                                value="Mood_3" />
                            Expansive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_4"
                                name="cbMood_4"
                                className='add-only'
                                value="Mood_4" />
                            Irritable;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_5"
                                name="cbMood_5"
                                className='add-only'
                                value="Mood_5" />
                            Labile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_6"
                                name="cbMood_6"
                                className='add-only'
                                value="Mood_6" />
                            Elevated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_7"
                                name="cbMood_7"
                                className='add-only'
                                value="Mood_7" />
                            Euphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_8"
                                name="cbMood_8"
                                className='add-only'
                                value="Mood_8" />
                            Ecstatic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_9"
                                name="cbMood_9"
                                className='add-only'
                                value="Mood_9" />
                            Depressed;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_10"
                                name="cbMood_10"
                                className='add-only'
                                value="Mood_10" />
                            Grief/mourning;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_11"
                                name="cbMood_11"
                                className='add-only'
                                value="Mood_11" />
                            Alexithymic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_12"
                                name="cbMood_12"
                                className='add-only'
                                value="Mood_12" />
                            Elated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_13"
                                name="cbMood_13"
                                className='add-only'
                                value="Mood_13" />
                            Hypomanic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_14"
                                name="cbMood_14"
                                className='add-only'
                                value="Mood_14" />
                            Manic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_15"
                                name="cbMood_15"
                                className='add-only'
                                value="Mood_15" />
                            Anxious;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_16"
                                name="cbMood_16"
                                className='add-only'
                                value="Mood_16" />
                            Tense;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMood_17"
                                name="cbMood_17"
                                className='add-only'
                                value="Mood_17" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtMood_17"
                                name="txtMood_17"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>f. AFFECT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_1"
                                name="cbAffect_1"
                                className='add-only'
                                value="Affect_1" />
                            Appropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_2"
                                name="cbAffect_2"
                                className='add-only'
                                value="Affect_2" />
                            Inappropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_3"
                                name="cbAffect_3"
                                className='add-only'
                                value="Affect_3" />
                            Blunted;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_4"
                                name="cbAffect_4"
                                className='add-only'
                                value="Affect_4" />
                            Restricted;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_5"
                                name="cbAffect_5"
                                className='add-only'
                                value="Affect_5" />
                            Flat;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_6"
                                name="cbAffect_6"
                                className='add-only'
                                value="Affect_6" />
                            Labile;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_7"
                                name="cbAffect_7"
                                className='add-only'
                                value="Affect_7" />
                            Tearful;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_8"
                                name="cbAffect_8"
                                className='add-only'
                                value="Affect_8" />
                            Intense;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbAffect_9"
                                name="cbAffect_9"
                                className='add-only'
                                value="Affect_9" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtAffect_9"
                                name="txtAffect_9"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_1"
                                name="cbPerceptualDisturbances_1"
                                className='add-only'
                                value="PerceptualDisturbances_1" />
                            None;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_2"
                                name="cbPerceptualDisturbances_2"
                                className='add-only'
                                value="PerceptualDisturbances_2" />
                            Hallucinations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_3"
                                name="cbPerceptualDisturbances_3"
                                className='add-only'
                                value="PerceptualDisturbances_3" />
                            Auditory;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_4"
                                name="cbPerceptualDisturbances_4"
                                className='add-only'
                                value="PerceptualDisturbances_4" />
                            Visual;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_5"
                                name="cbPerceptualDisturbances_5"
                                className='add-only'
                                value="PerceptualDisturbances_5" />
                            Olfactory;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_6"
                                name="cbPerceptualDisturbances_6"
                                className='add-only'
                                value="PerceptualDisturbances_6" />
                            Tactile;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbPerceptualDisturbances_7"
                                name="cbPerceptualDisturbances_7"
                                className='add-only'
                                value="PerceptualDisturbances_7" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtPerceptualDisturbances_7"
                                name="txtPerceptualDisturbances_7"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>h. THOUGHT PROCESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_1"
                                name="cbThoughtProcess_1"
                                className='add-only'
                                value="ThoughtProcess_1" />
                            Logical/Coherent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_2"
                                name="cbThoughtProcess_2"
                                className='add-only'
                                value="ThoughtProcess_2" />
                            Incomprehensible;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_3"
                                name="cbThoughtProcess_3"
                                className='add-only'
                                value="ThoughtProcess_3" />
                            Incoherent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_4"
                                name="cbThoughtProcess_4"
                                className='add-only'
                                value="ThoughtProcess_4" />
                            Flight of Ideas;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_5"
                                name="cbThoughtProcess_5"
                                className='add-only'
                                value="ThoughtProcess_5" />
                            Loose Associations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_6"
                                name="cbThoughtProcess_6"
                                className='add-only'
                                value="ThoughtProcess_6" />
                            Tangential;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_7"
                                name="cbThoughtProcess_7"
                                className='add-only'
                                value="ThoughtProcess_7" />
                            Circumstantial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_8"
                                name="cbThoughtProcess_8"
                                className='add-only'
                                value="ThoughtProcess_8" />
                            Rambling;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_9"
                                name="cbThoughtProcess_9"
                                className='add-only'
                                value="ThoughtProcess_9" />
                            Evasive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_10"
                                name="cbThoughtProcess_10"
                                className='add-only'
                                value="ThoughtProcess_10" />
                            Racing Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_11"
                                name="cbThoughtProcess_11"
                                className='add-only'
                                value="ThoughtProcess_11" />
                            Perseveration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_12"
                                name="cbThoughtProcess_12"
                                className='add-only'
                                value="ThoughtProcess_12" />
                            Thought Blocking;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_13"
                                name="cbThoughtProcess_13"
                                className='add-only'
                                value="ThoughtProcess_13" />
                            Concrete;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtProcess_14"
                                name="cbThoughtProcess_14"
                                className='add-only'
                                value="ThoughtProcess_14" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtThoughtProcess_14"
                                name="txtThoughtProcess_14"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>i. THOUGHT CONTENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_2"
                                name="cbThoughtContent_2"
                                className='add-only'
                                value="ThoughtContent_2" />
                            Preoccupations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_3"
                                name="cbThoughtContent_3"
                                className='add-only'
                                value="ThoughtContent_3" />
                            Obsessions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_4"
                                name="cbThoughtContent_4"
                                className='add-only'
                                value="ThoughtContent_4" />
                            Compulsions;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_5"
                                name="cbThoughtContent_5"
                                className='add-only'
                                value="ThoughtContent_5" />
                            Phobias;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_6"
                                name="cbThoughtContent_6"
                                className='add-only'
                                value="ThoughtContent_6" />
                            Delusions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_7"
                                name="cbThoughtContent_7"
                                className='add-only'
                                value="ThoughtContent_7" />
                            Thought Broadcasting;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_8"
                                name="cbThoughtContent_8"
                                className='add-only'
                                value="ThoughtContent_8" />
                            Thought Insertion;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_9"
                                name="cbThoughtContent_9"
                                className='add-only'
                                value="ThoughtContent_9" />
                            Thought Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_10"
                                name="cbThoughtContent_10"
                                className='add-only'
                                value="ThoughtContent_10" />
                            Ideas of Reference;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_11"
                                name="cbThoughtContent_11"
                                className='add-only'
                                value="ThoughtContent_11" />
                            Ideas of Influence;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_12"
                                name="cbThoughtContent_12"
                                className='add-only'
                                value="ThoughtContent_12" />
                            Delusions;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbThoughtContent_13"
                                name="cbThoughtContent_13"
                                className='add-only'
                                value="ThoughtContent_13" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtThoughtContent_13"
                                name="txtThoughtContent_13"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>j. SUICIDAL/HOMICIDAL IDEATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_1"
                                name="cbSuicidalHomicidalIdeation_1"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_1" />
                            Suicidal Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_2"
                                name="cbSuicidalHomicidalIdeation_2"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_2" />
                            Suicidal Attempts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_3"
                                name="cbSuicidalHomicidalIdeation_3"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_3" />
                            Suicidal Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_4"
                                name="cbSuicidalHomicidalIdeation_4"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_4" />
                            Suicidal Plans;
                        </td>

                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_5"
                                name="cbSuicidalHomicidalIdeation_5"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_5" />
                            History of Self-Injurious Behavior;
                        </td>

                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_6"
                                name="cbSuicidalHomicidalIdeation_6"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_6" />
                            Homicidal Thoughts;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_7"
                                name="cbSuicidalHomicidalIdeation_7"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_7" />
                            Homicidal Attempts;
                        </td>

                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_8"
                                name="cbSuicidalHomicidalIdeation_8"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_8" />
                            Homicidal Intent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_9"
                                name="cbSuicidalHomicidalIdeation_9"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_9" />
                            Homicidal Plans;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbSuicidalHomicidalIdeation_10"
                                name="cbSuicidalHomicidalIdeation_10"
                                className='add-only'
                                value="SuicidalHomicidalIdeation_10" />Other/Describe:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtSuicidalHomicidalIdeation_4"
                                name="txtSuicidalHomicidalIdeation_4"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>k. SENSORIUM/COGNITION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_1"
                                name="cbSensoriumCognition_1"
                                className='add-only'
                                value="SensoriumCognition_1" />
                            Alert;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_2"
                                name="cbSensoriumCognition_2"
                                className='add-only'
                                value="SensoriumCognition_2" />
                            Lethargic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_3"
                                name="cbSensoriumCognition_3"
                                className='add-only'
                                value="SensoriumCognition_3" />
                            Somnolent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_4"
                                name="cbSensoriumCognition_4"
                                className='add-only'
                                value="SensoriumCognition_4" />
                            Stuporous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_5"
                                name="cbSensoriumCognition_5"
                                className='add-only'
                                value="SensoriumCognition_5" />
                            Normal Concentration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_6"
                                name="cbSensoriumCognition_6"
                                className='add-only'
                                value="SensoriumCognition_6" />
                            Impaired Concentration;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbSensoriumCognition_7"
                                name="cbSensoriumCognition_7"
                                className='add-only'
                                value="SensoriumCognition_7" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtSensoriumCognition_7"
                                name="txtSensoriumCognition_7"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><strong>Oriented to:</strong></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbOrientation_1"
                                name="cbOrientation_1"
                                className='add-only'
                                value="Orientation_1" />
                            Person;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbOrientation_2"
                                name="cbOrientation_2"
                                className='add-only'
                                value="Orientation_2" />
                            Place;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbOrientation_3"
                                name="cbOrientation_3"
                                className='add-only'
                                value="Orientation_3" />
                            Time;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbOrientation_4"
                                name="cbOrientation_4"
                                className='add-only'
                                value="Orientation_4" />
                            Situation;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>l. MEMORY</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><strong>Remote Memory:</strong></td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRemoteMemory_1"
                                name="cbRemoteMemory_1"
                                className='add-only'
                                value="RemoteMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRemoteMemory_2"
                                name="cbRemoteMemory_2"
                                className='add-only'
                                value="RemoteMemory_2" />
                            Impaired;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><strong>Recent Memory:</strong></td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecentMemory_1"
                                name="cbRecentMemory_1"
                                className='add-only'
                                value="RecentMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecentMemory_2"
                                name="cbRecentMemory_2"
                                className='add-only'
                                value="RecentMemory_2" />
                            Impaired;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <strong>Immediate Recall:</strong>
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImmediateMemory_1"
                                name="cbImmediateMemory_1"
                                className='add-only'
                                value="ImmediateMemory_1" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImmediateMemory_2"
                                name="cbImmediateMemory_2"
                                className='add-only'
                                value="ImmediateMemory_2" />
                            Impaired;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbMemoryOtherDescribe"
                                name="cbMemoryOtherDescribe"
                                className='add-only'
                                value="MemoryOtherDescribe" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtMemoryOtherDescribe"
                                name="txtMemoryOtherDescribe"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>m. INTELLECTUAL FUNCTIONING (Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualFunctioning_1"
                                name="cbIntellectualFunctioning_1"
                                className='add-only'
                                value="IntellectualFunctioning_1" />
                            Above Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualFunctioning_2"
                                name="cbIntellectualFunctioning_2"
                                className='add-only'
                                value="IntellectualFunctioning_2" />
                            Normal/Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualFunctioning_3"
                                name="cbIntellectualFunctioning_3"
                                className='add-only'
                                value="IntellectualFunctioning_3" />
                            Borderline;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <strong>Mental Retardation:</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualDiability_1"
                                name="cbIntellectualDiability_1"
                                className='add-only'
                                value="IntellectualDiability_1" />
                            Mild;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualDiability_2"
                                name="cbIntellectualDiability_2"
                                className='add-only'
                                value="IntellectualDiability_2" />
                            Moderate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualDiability_3"
                                name="cbIntellectualDiability_3"
                                className='add-only'
                                value="IntellectualDiability_3" />
                            Severe;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbIntellectualDiability_4"
                                name="cbIntellectualDiability_4"
                                className='add-only'
                                value="IntellectualDiability_4" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtIntellectualDiability_4"
                                name="txtIntellectualDiability_4"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>n. JUDGMENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbJudgment_1"
                                name="cbJudgment_1"
                                className='add-only'
                                value="Judgment_1" />
                            Critical Judgment Intact;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbJudgment_2"
                                name="cbJudgment_2"
                                className='add-only'
                                value="Judgment_2" />
                            Impaired Judgment;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbJudgment_3"
                                name="cbJudgment_3"
                                className='add-only'
                                value="Judgment_3" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtJudgment_3"
                                name="txtJudgment_3"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>o. INSIGHT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbInsight_1"
                                name="cbInsight_1"
                                className='add-only'
                                value="Insight_1" />
                            True Emotional Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbInsight_2"
                                name="cbInsight_2"
                                className='add-only'
                                value="Insight_2" />
                            Intellectual Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbInsight_3"
                                name="cbInsight_3"
                                className='add-only'
                                value="Insight_3" />
                            Impaired Insight;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbInsight_4"
                                name="cbInsight_4"
                                className='add-only'
                                value="Insight_4" />
                            Denial;
                        </td>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbInsight_5"
                                name="cbInsight_5"
                                className='add-only'
                                value="Insight_5" />
                            Some Awareness of Illness/symptoms;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbInsight_6"
                                name="cbInsight_6"
                                className='add-only'
                                value="Insight_6" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtInsight_6"
                                name="txtInsight_6"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>p. IMPULSE CONTROL</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImpulseControl_1"
                                name="cbImpulseControl_1"
                                className='add-only'
                                value="ImpulseControl_1" />
                            Able to Resist Impulses;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImpulseControl_2"
                                name="cbImpulseControl_2"
                                className='add-only'
                                value="ImpulseControl_2" />
                            Recent Impulsive Behavior;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImpulseControl_3"
                                name="cbImpulseControl_3"
                                className='add-only'
                                value="ImpulseControl_3" />
                            Impaired Impulse Control;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImpulseControl_4"
                                name="cbImpulseControl_4"
                                className='add-only'
                                value="ImpulseControl_4" />
                            Compulsions;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbImpulseControl_5"
                                name="cbImpulseControl_5"
                                className='add-only'
                                value="ImpulseControl_5" />Other/Describe:
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input
                                type="text"
                                id="txtImpulseControl_5"
                                name="txtImpulseControl_5"
                                className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <strong>XVII. RISK ASSESSMENT:</strong>
                    <span className='small'>Assess potential risk of harm to self or others, including
                        patterns of risk behavior and/or risk due to personality
                        factors, substance use, criminogenic factors, exposure to
                        elements, exploitation, abuse, neglect, suicidal or homicidal
                        history, self-injury, psychosis, impulsiveness, etc.
                    </span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Risk of Harm to Self:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_2"
                                name="cbRiskHarmSelf_2"
                                className='add-only'
                                value="RiskHarmSelf_2" />
                            Prior Suicide Attempt;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_3"
                                name="cbRiskHarmSelf_3"
                                className='add-only'
                                value="RiskHarmSelf_3" />
                            Stated Plan/Intent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_4"
                                name="cbRiskHarmSelf_4"
                                className='add-only'
                                value="RiskHarmSelf_4" />
                            Access to means (weapons, pills, etc.);
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_5"
                                name="cbRiskHarmSelf_5"
                                className='add-only'
                                value="RiskHarmSelf_5" />
                            Recent Loss;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_6"
                                name="cbRiskHarmSelf_6"
                                className='add-only'
                                value="RiskHarmSelf_6" />
                            Presence of Behavioral Cues (isolation, giving away
                            possessions, rapid mood swings, etc.);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_7"
                                name="cbRiskHarmSelf_7"
                                className='add-only'
                                value="RiskHarmSelf_7" />
                            Family History of Suicide;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_8"
                                name="cbRiskHarmSelf_8"
                                className='add-only'
                                value="RiskHarmSelf_8" />
                            Terminal Illness;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_9"
                                name="cbRiskHarmSelf_9"
                                className='add-only'
                                value="RiskHarmSelf_9" />
                            Substance Abuse;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_10"
                                name="cbRiskHarmSelf_10"
                                className='add-only'
                                value="RiskHarmSelf_10" />
                            Marked lack of support;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_11"
                                name="cbRiskHarmSelf_11"
                                className='add-only'
                                value="RiskHarmSelf_11" />
                            Psychosis;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_12"
                                name="cbRiskHarmSelf_12"
                                className='add-only'
                                value="RiskHarmSelf_12" />
                            Suicide of friend/acquaintance;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmSelf_13"
                                name="cbRiskHarmSelf_13"
                                className='add-only'
                                value="RiskHarmSelf_13" />Other/Describe:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRiskHarmSelf_13"
                                name="txtRiskHarmSelf_13"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. Risk of Harm to Others:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_2"
                                name="cbRiskHarmOthers_2"
                                className='add-only'
                                value="RiskHarmOthers_2" /> prior acts of violence; act?
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_3"
                                name="cbRiskHarmOthers_3"
                                className='add-only'
                                value="RiskHarmOthers_3" />
                            Destruction of property;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_4"
                                name="cbRiskHarmOthers_4"
                                className='add-only'
                                value="RiskHarmOthers_4" />
                            Arrests for violence;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_5"
                                name="cbRiskHarmOthers_5"
                                className='add-only'
                                value="RiskHarmOthers_5" />
                            Access to means (weapons);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_6"
                                name="cbRiskHarmOthers_6"
                                className='add-only'
                                value="RiskHarmOthers_6" />
                            Substance use;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_7"
                                name="cbRiskHarmOthers_7"
                                className='add-only'
                                value="RiskHarmOthers_7" />
                            Physically abused as child;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_8"
                                name="cbRiskHarmOthers_8"
                                className='add-only'
                                value="RiskHarmOthers_8" />
                            Was physically abusive as a child;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_9"
                                name="cbRiskHarmOthers_9"
                                className='add-only'
                                value="RiskHarmOthers_9" />
                            Harms animals;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_10"
                                name="cbRiskHarmOthers_10"
                                className='add-only'
                                value="RiskHarmOthers_10" />
                            Fire setting;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_11"
                                name="cbRiskHarmOthers_11"
                                className='add-only'
                                value="RiskHarmOthers_11" />
                            angry mood/agitation;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_12"
                                name="cbRiskHarmOthers_12"
                                className='add-only'
                                value="RiskHarmOthers_12" />
                            Prior hospitalizations for danger to others;
                        </td>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_13"
                                name="cbRiskHarmOthers_13"
                                className='add-only'
                                value="RiskHarmOthers_13" />
                            Psychosis/command hallucinations;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox"
                                id="cbRiskHarmOthers_14"
                                name="cbRiskHarmOthers_14"
                                className='add-only'
                                value="RiskHarmOthers_14" />Other/Describe:
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input
                                type="text"
                                id="txtRiskHarmOthers_14"
                                name="txtRiskHarmOthers_14"
                                className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>c. Client/Member Safety & Other Risk Factors :</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_1' name='cbClientMemberSafety_1' className='add-only' value='ClientMemberSafety_1' /> Feels unsafe in current living environment; </td>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_2' name='cbClientMemberSafety_2' className='add-only' value='ClientMemberSafety_2' /> Engages in dangerous sexual behavior;  </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_3' name='cbClientMemberSafety_3' className='add-only' value='ClientMemberSafety_3' /> Feels currently being harmed/ hurt/ abused/ threatened by someone; </td>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_4' name='cbClientMemberSafety_4' className='add-only' value='ClientMemberSafety_4' /> Past involvement with Child or Adult Protective Services; </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_5' name='cbClientMemberSafety_5' className='add-only' value='ClientMemberSafety_5' /> Relapse/decompensation triggers; </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbClientMemberSafety_6' name='cbClientMemberSafety_6' className='add-only' value='ClientMemberSafety_6' /> Other/Describe: &nbsp;
                            <input type='text' id='txtClientMemberSafety_6Other' name='txtClientMemberSafety_6Other' placeholder='' className='add-only w-200 custom-add-only' /></td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>d. </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbRiskAssessmentD_1' name='cbRiskAssessmentD_1' className='add-only' value='RiskAssessmentD_1' /> Inappropriate sexual behaviors </td>
                        <td className='w-375'> <input type='checkbox' id='cbRiskAssessmentD_2' name='cbRiskAssessmentD_2' className='add-only' value='RiskAssessmentD_2' /> Sex offender status </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbRiskAssessmentD_3' name='cbRiskAssessmentD_3' className='add-only' value='RiskAssessmentD_3' /> Pending sex offense charge </td>
                        <td className='w-375'> <input type='checkbox' id='cbRiskAssessmentD_4' name='cbRiskAssessmentD_4' className='add-only' value='RiskAssessmentD_4' /> Report or Investigation </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbRiskAssessmentD_5' name='cbRiskAssessmentD_5' className='add-only' value='RiskAssessmentD_5' /> Other:&nbsp;
                            <input type='text' id='txtRiskAssessmentD_5Other' name='txtRiskAssessmentD_5Other' placeholder='' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'>
                    <span className='eleHeader'> e. Additional Risk Factors:</span>
                    <textarea id="txtAdditionalRiskFactors" name="txtAdditionalRiskFactors" className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>f. Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to
                        periods of decompensation/relapse:</span>
                    <span className='small'> (Ex. Resources recipient feels comfortable reaching out to for assistance in a crisis.)</span>
                    <textarea id="txtDescriberecipientspreferences" name="txtDescriberecipientspreferences" className='add-only'></textarea>

                </p>

                <p className='w-750'>
                    <strong>XVIII. CULTURAL AND LANGUAGE PREFERENCES</strong>
                    <span className='small'>(Language, Customs/Values/Preferences)</span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>a. Spiritual Beliefs/Preferences:
                    </span>
                    <textarea id="txtSpiritualBeliefsPreferences"
                        name="txtSpiritualBeliefsPreferences"
                        className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Cultural Beliefs/Preferences:
                    </span>
                    <textarea id="txtCulturalBeliefsPreferences"
                        name="txtCulturalBeliefsPreferences"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <strong>XIX. PRINCIPAL DIAGNOSES </strong>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>AXIS I</span>
                    <textarea id="txtPrincipalDiagnoses_Axis1" name="txtPrincipalDiagnoses_Axis1" className='add-only'></textarea>
                    <span className='eleHeader'>AXIS II</span>
                    <textarea id="txtPrincipalDiagnoses_Axis2" name="txtPrincipalDiagnoses_Axis2" className='add-only'></textarea>
                    <span className='eleHeader'>AXIS III</span>
                    <textarea id="txtPrincipalDiagnoses_Axis3" name="txtPrincipalDiagnoses_Axis3" className='add-only'></textarea>
                    <span className='eleHeader'>AXIS IV</span>
                    <textarea id="txtPrincipalDiagnoses_Axis4" name="txtPrincipalDiagnoses_Axis4" className='add-only'></textarea>
                    <span className='eleHeader'>AXIS V</span>
                    <textarea id="txtPrincipalDiagnoses_Axis5" name="txtPrincipalDiagnoses_Axis5" className='add-only'></textarea>
                </p>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Current:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Highest Past Year:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtCurrentPastYear' name='txtCurrentPastYear' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtHighestPastYear' name='txtHighestPastYear' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <strong>XX. INTERPRATIVE SUMMARY </strong>
                    <span className='small'> Briefly describe client/member's global preferences/hopes for recovery, your clinical summary, and recommended
                        treatments/assessments, level of care, duration.
                    </span>

                    <textarea id="txtInterpretativeSummary"
                        name="txtInterpretativeSummary"
                        className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>a. RECCOMMENDED SERVICES</span>
                    <span className='small'>(Check all that apply.)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_1"
                                name="cbRecommendedServicesMh_1"
                                className='add-only'
                                value="RecommendedServicesMh_1" /> Family Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_2"
                                name="cbRecommendedServicesMh_2"
                                className='add-only'
                                value="RecommendedServicesMh_2" /> Individual Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_3"
                                name="cbRecommendedServicesMh_3"
                                className='add-only'
                                value="RecommendedServicesMh_3" /> Group Therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_4"
                                name="cbRecommendedServicesMh_4"
                                className='add-only'
                                value="RecommendedServicesMh_4" /> Alcohol/Drug Assessment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_5"
                                name="cbRecommendedServicesMh_5"
                                className='add-only'
                                value="RecommendedServicesMh_5" /> Alcohol/ Drug Individual Therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_6"
                                name="cbRecommendedServicesMh_6"
                                className='add-only'
                                value="RecommendedServicesMh_6" /> PSR
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_7"
                                name="cbRecommendedServicesMh_7"
                                className='add-only'
                                value="RecommendedServicesMh_7" /> CPST
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbRecommendedServicesMh_7"
                                name="cbRecommendedServicesMh_7"
                                className='add-only'
                                value="RecommendedServicesMh_7" /> Other/Describe:
                            <input type='text' id='txtRecommendedServicesMh_7Other' name='txtRecommendedServicesMh_7Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader' >b. Other Services/Linkages Needed:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_1"
                                name="cbLinkagesNeededSa_1"
                                className='add-only'
                                value="LinkagesNeededSa_1" /> Vocational Services
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_2"
                                name="cbLinkagesNeededSa_2"
                                className='add-only'
                                value="LinkagesNeededSa_2" /> Social Services
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_3"
                                name="cbLinkagesNeededSa_3"
                                className='add-only'
                                value="LinkagesNeededSa_3" /> Educational Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_4"
                                name="cbLinkagesNeededSa_4"
                                className='add-only'
                                value="LinkagesNeededSa_4" /> Medical Services/PCP
                        </td>
                        <td className='w-250'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_5"
                                name="cbLinkagesNeededSa_5"
                                className='add-only'
                                value="LinkagesNeededSa_5" /> Self help Groups
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox"
                                id="cbLinkagesNeededSa_6"
                                name="cbLinkagesNeededSa_6"
                                className='add-only'
                                value="LinkagesNeededSa_6" /> Other/Describe:
                            <input type='text' id='txtLinkagesNeededSa_6Other' name='txtLinkagesNeededSa_6Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader' >c. Additional Comments:</span>
                    <textarea id="txtXX_AdditionalComments"
                        name="txtXX_AdditionalComments"
                        className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <strong>SIGNATURE</strong>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-375">PRINTED NAME OF ASSESSOR:</td>
                        <td className="small w-375">SIGNATURE:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-375">LMHP STATUS:</td>
                        <td className="small w-375">DATE:</td>
                    </tr>
                </table>
            </div>
        </form>

    )
}







